// packages/web/src/lib/radarKind.ts — R3d (C1): ONE formula for the kind
// chip every item row (topic screen, proposal spread's item card) leads
// with — a WORD, never an icon alone (the-voice-canon's own rule on icons
// standing in for words). 'article' is the fallback for a null/unrecognised
// kind (an old row from before P1 widened the column, or a build that
// predates it entirely) — never a blank chip.
export function kindChipLabel(kind: string | null | undefined, durationSeconds: number | null | undefined): string {
  const minutes = durationSeconds && durationSeconds > 0 ? Math.max(1, Math.round(durationSeconds / 60)) : null;
  if (kind === 'video') return minutes ? `video ${minutes} min` : 'video';
  if (kind === 'audio') return minutes ? `audio ${minutes} min` : 'audio';
  return 'article';
}
